var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},_vm._l((_vm.shapeEntries),function(item){return _c('div',{key:item.key,staticClass:"title-card"},[_c('div',{staticClass:"locker-type-title"},[_vm._v("\n      "+_vm._s(item.key)+"\n    ")]),_c('div',{staticClass:"locker-type-count"},[_vm._v("\n      "+_vm._s(item.available)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }